// src/lib/wagmi.ts
import { createConfig, http } from "wagmi";
import { base } from "wagmi/chains";

const RPC_URL = import.meta.env.VITE_RPC_URL;

if (!RPC_URL) throw new Error("VITE_RPC_URL is not defined");

export const wagmiConfig = createConfig({
  chains: [base],
  transports: {
    [base.id]: http(RPC_URL),
  },
});
